"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionCapturer = exports.LoggerTransport = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Trace"] = 1] = "Trace";
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Warn"] = 4] = "Warn";
    LogLevel[LogLevel["Error"] = 5] = "Error";
    LogLevel[LogLevel["Fatal"] = 6] = "Fatal";
})(LogLevel || (LogLevel = {}));
exports.LogLevel = LogLevel;
var LoggerTransport = /** @class */ (function () {
    function LoggerTransport() {
    }
    LoggerTransport.prototype.log = function (level, message, context) { };
    return LoggerTransport;
}());
exports.LoggerTransport = LoggerTransport;
var ExceptionCapturer = /** @class */ (function () {
    function ExceptionCapturer() {
    }
    ExceptionCapturer.prototype.captureException = function (error, context) { };
    ExceptionCapturer.prototype.captureMessage = function (message, context) { };
    return ExceptionCapturer;
}());
exports.ExceptionCapturer = ExceptionCapturer;
